import useCollection from "./useCollection"

export default function useLocationPhotos(locationId) {
  return useCollection({ key: `/locations/${locationId}/images` })
}
